import React, { Component } from "react";
import Layout from "./components/Layout/";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";

import routes from "./routes";
import "./custom.css";
import "./App.scss";

// Get all Auth methods
import {
  isUserAuthenticated,
  removeLoggedInUserDetails,
} from "./helpers/authUtils";

function withLayout(WrappedComponent) {
  // ...and returns another component...
  return class extends React.Component {
    render() {
      // scroll restoration
      window.scrollTo(0, 0);

      return (
        <Layout>
          <WrappedComponent></WrappedComponent>
        </Layout>
      );
    }
  };
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const PrivateRoute = ({ component: Component, ...rest }) => {
      if (!isUserAuthenticated()) {
        removeLoggedInUserDetails();
        return <Redirect to="/login" />;
      }
      return (
        <Route
          {...rest}
          render={(props) =>
            isUserAuthenticated() === true ? (
              <Component {...props} />
            ) : (
              <Redirect to="/login" />
            )
          }
        />
      );
    };

    return (
      <React.Fragment>
        <Router>
          <Switch>
            {routes.map((route, idx) =>
              route.ispublic ? (
                <Route
                  exact
                  path={route.path}
                  component={route.component}
                  key={idx}
                />
              ) : (
                <PrivateRoute
                  exact
                  path={route.path}
                  component={withLayout(route.component)}
                  key={idx}
                />
              )
            )}
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

export default App;
